import React, { Component } from "react";
import { scaleRotate as Menu } from "react-burger-menu";
import { Image, Icon } from "semantic-ui-react";
import { Link } from "react-router-dom";

class Sidebar extends Component {
  menuItems = [
    { to: "/", label: "Home" },
    { to: "/projects", label: "Projects" },
    { to: "/articles", label: "Articles" },
    {
      href: "/static/images/gerard_gueco_cv.pdf",
      label: "Resumé",
      external: true,
    },
  ];

  socialLinks = [
    {
      href: "https://medium.com/@gerardgueco",
      icon: "medium",
      title: "Medium",
    },
    {
      href: "https://www.youtube.com/channel/UC1bQUFzHdunG_62gVVQxn9g",
      icon: "youtube square",
      title: "YouTube",
    },
    {
      href: "https://github.com/gerardbrian19",
      icon: "github square",
      title: "GitHub",
    },
  ];

  componentDidUpdate(prevProps) {
    if (prevProps.active !== this.props.active) {
      console.log(this.props.active);
    }
  }

  render() {
    const { active, ...menuProps } = this.props;

    return (
      <Menu {...menuProps}>
        <div className="bm-item nav-content">
          <Image
            src="/static/images/logo-light1.png"
            className="logo"
            alt="Logo"
          />

          <div className="links">
            {this.menuItems.map(({ to, href, label, external }) =>
              external ? (
                <a
                  key={label}
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="menu-item"
                >
                  {label}
                </a>
              ) : (
                <Link
                  key={label}
                  to={to}
                  className={`menu-item ${
                    active === label.toLowerCase() ? "active" : ""
                  }`}
                >
                  {label}
                </Link>
              )
            )}
          </div>

          <div className="social-icons">
            {this.socialLinks.map(({ href, icon, title }) => (
              <a
                key={title}
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                title={title}
              >
                <Icon name={icon} />
              </a>
            ))}
          </div>
        </div>
      </Menu>
    );
  }
}

export default Sidebar;
